module.exports = __webpack_public_path__ + "static/add-more-3df734fcc281541e8b97e569f9d04027.png";